var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "editable-cell"
  }, [_vm.editable ? _c("div", {
    staticClass: "editable-cell-input-wrapper",
    staticStyle: {
      position: "relative"
    }
  }, [_c("a-form-model", {
    ref: "form1",
    staticStyle: {
      width: "80%"
    },
    attrs: {
      model: _vm.form,
      rules: _vm.rules
    }
  }, [_vm.textAlign == "right" ? [_c("a-form-model-item", {
    attrs: {
      label: "",
      prop: "value"
    }
  }, [_c("a-input", {
    staticStyle: {
      "margin-right": "8px",
      "text-align": "right"
    },
    attrs: {
      value: _vm.form.value
    },
    on: {
      change: _vm.handleChange,
      pressEnter: _vm.check
    }
  })], 1)] : [_c("a-form-model-item", {
    attrs: {
      label: "",
      prop: "replyContent"
    }
  }, [_c("a-input", {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      value: _vm.form.value
    },
    on: {
      change: _vm.handleChange,
      pressEnter: _vm.check
    }
  })], 1)]], 2), _c("a-icon", {
    staticClass: "editable-cell-icon-check",
    staticStyle: {
      position: "absolute",
      top: "12px",
      right: "0px"
    },
    attrs: {
      type: "check"
    },
    on: {
      click: _vm.check
    }
  })], 1) : _c("div", {
    staticClass: "editable-cell-text-wrapper"
  }, [_vm._v(" " + _vm._s(_vm.form.value || " ") + " "), _c("a-icon", {
    staticClass: "editable-cell-icon",
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.edit
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };